module.exports = __webpack_public_path__ + "img/image-7.26dccbbd.jpg";